import cookieConsent from './cookieConsent';
import videolink from './videolink';

document.addEventListener('DOMContentLoaded', () => {
    cookieConsent();
    videolink();
});



// WEBPACK FOOTER //
// ./src/Cwa/SiteBundle/Resources/ui/js/app.js